<div class="container">
  <h1>PRIVACY POLICY</h1>

  <p>Last updated&#160;August 04, 2023</p>

  <p>
    This privacy notice for&#160;NCOM d.o.o.&#160;(&quot;Company,&quot;
    &quot;we,&quot; &quot;us,&quot; or &quot;our&quot;), describes how and why
    we might collect, store, use, and/or share (&quot;process&quot;) your
    information when you use our services (&quot;Services&quot;), such as when
    you: Visit our website&#160;at&#160;<a href="https://dashboard.razzl.app/"
      >dashboard.razzl.app</a
    >, or any website of ours that links to this privacy notice
  </p>

  <p>
    Engage with us in other related ways, including any sales, marketing, or
    events Questions or concerns?&#160;Reading this privacy notice will help you
    understand your privacy rights and choices. If you do not agree with our
    policies and practices, please do not use our Services. If you still have
    any questions or concerns, please contact us at&#160;<a
      href="mailto:info@razzle.com"
      >info&#64;razzle.com</a
    >.
  </p>

  <h1>SUMMARY OF KEY POINTS</h1>

  <p>
    This summary provides key points from our privacy notice, but you can find
    out more details about any of these topics by clicking the link following
    each key point or by using our&#160;table of contents&#160;below to find the
    section you are looking for.
  </p>

  <p>
    What personal information do we process?&#160;When you visit, use, or
    navigate our Services, we may process personal information depending on how
    you interact with&#160;NCOM d.o.o.&#160;and the Services, the choices you
    make, and the products and features you use. Learn more about&#160;personal
    information you disclose to us.
  </p>

  <p>
    Do we process any sensitive personal information?&#160;We may process
    sensitive personal information when necessary with your consent or as
    otherwise permitted by applicable law. Learn more about&#160;sensitive
    information we process.
  </p>

  <p>
    Do we receive any information from third parties?&#160;We do not receive any
    information from third parties.
  </p>

  <p>
    How do we process your information?&#160;We process your information to
    provide, improve, and administer our Services, communicate with you, for
    security and fraud prevention, and to comply with law. We may also process
    your information for other purposes with your consent. We process your
    information only when we have a valid legal reason to do so. Learn more
    about&#160;how we process your information.
  </p>

  <p>
    In what situations and with which&#160;parties do we share personal
    information?&#160;We may share information in specific situations and with
    specific&#160;third parties. Learn more about&#160;when and with whom we
    share your personal information.
  </p>

  <p>
    How do we keep your information safe?&#160;We
    have&#160;organizational&#160;and technical processes and procedures in
    place to protect your personal information. However, no electronic
    transmission over the internet or information storage technology can be
    guaranteed to be 100% secure, so we cannot promise or guarantee that
    hackers, cybercriminals, or other&#160;unauthorized&#160;third parties will
    not be able to defeat our security and improperly collect, access, steal, or
    modify your information. Learn more about&#160;how we keep your information
    safe.
  </p>

  <p>
    What are your rights?&#160;Depending on where you are located
    geographically, the applicable privacy law may mean you have certain rights
    regarding your personal information. Learn more about&#160;your privacy
    rights.
  </p>

  <p>
    How do you exercise your rights?&#160;The easiest way to exercise your
    rights is by&#160;submitting a&#160;data subject access request, or by
    contacting us. We will consider and act upon any request in accordance with
    applicable data protection laws.
  </p>

  <p>
    Want to learn more about what&#160;NCOM d.o.o.&#160;does with any
    information we collect?&#160;Review the privacy notice in full.
  </p>

  <h1>TABLE OF CONTENTS</h1>

  <ol>
    <li>WHAT INFORMATION DO WE COLLECT?</li>
    <li>HOW DO WE PROCESS YOUR INFORMATION?</li>
    <li>
      WHAT LEGAL BASES DO WE RELY ON TO PROCESS YOUR PERSONAL INFORMATION?
    </li>
    <li>WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?</li>
    <li>DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?</li>
    <li>HOW LONG DO WE KEEP YOUR INFORMATION?</li>
    <li>HOW DO WE KEEP YOUR INFORMATION SAFE?</li>
    <li>DO WE COLLECT INFORMATION FROM MINORS?</li>
    <li>WHAT ARE YOUR PRIVACY RIGHTS?</li>
    <li>CONTROLS FOR DO-NOT-TRACK FEATURES</li>
    <li>DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?</li>
    <li>DO VIRGINIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?</li>
    <li>DO WE MAKE UPDATES TO THIS NOTICE?</li>
    <li>HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</li>
    <li>HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?</li>
  </ol>

  <h2>1. WHAT INFORMATION DO WE COLLECT?</h2>

  <p>Personal information you disclose to us</p>

  <p>In Short:&#160;We collect personal information that you provide to us.</p>

  <p>
    We collect personal information that you voluntarily provide to us when
    you&#160;register on the Services,&#160;express an interest in obtaining
    information about us or our products and Services, when you participate in
    activities on the Services, or otherwise when you contact us.
  </p>

  <p>
    Personal Information Provided by You.&#160;The personal information that we
    collect depends on the context of your interactions with us and the
    Services, the choices you make, and the products and features you use. The
    personal information we collect may include the following:
  </p>

  <ul>
    <li>names</li>
    <li>phone numbers</li>
    <li>email addresses</li>
    <li>job titles</li>
    <li>usernames</li>
    <li>passwords</li>
    <li>mailing addresses</li>
    <li>billing addresses</li>
  </ul>

  <p>
    Sensitive Information.&#160;When necessary, with your consent or as
    otherwise permitted by applicable law, we process the following categories
    of sensitive information: financial data, social security numbers or other
    government identifiers
  </p>

  <p>
    Payment Data.&#160;We may collect data necessary to process your payment if
    you make purchases, such as your payment instrument number, and the security
    code associated with your payment instrument.
  </p>

  <p>
    All personal information that you provide to us must be true, complete, and
    accurate, and you must notify us of any changes to such personal
    information.
  </p>

  <h2>2. HOW DO WE PROCESS YOUR INFORMATION?</h2>

  <p>
    In Short:&#160;We process your information to provide, improve, and
    administer our Services, communicate with you, for security and fraud
    prevention, and to comply with law. We may also process your information for
    other purposes with your consent.
  </p>

  <p>
    We process your personal information for a variety of reasons, depending on
    how you interact with our Services, including: To facilitate account
    creation and authentication and otherwise manage user accounts.&#160;We may
    process your information so you can create and log in to your account, as
    well as keep your account in working order.
  </p>

  <p>
    To deliver and facilitate delivery of services to the user.&#160;We may
    process your information to provide you with the requested service.
  </p>

  <p>
    To&#160;fulfill&#160;and manage your orders.&#160;We may process your
    information to&#160;fulfill&#160;and manage your orders, payments, returns,
    and exchanges made through the Services.
  </p>

  <p>
    To enable user-to-user communications.&#160;We may process your information
    if you choose to use any of our offerings that allow for communication with
    another user.
  </p>

  <p></p>

  <p>
    To save or protect an individual's vital interest.&#160;We may process your
    information when necessary to save or protect an individual&rsquo;s vital
    interest, such as to prevent harm.
  </p>

  <h2>3. WHAT LEGAL BASES DO WE RELY ON TO PROCESS YOUR INFORMATION?</h2>

  <p>
    In Short:&#160;We only process your personal information when we believe it
    is necessary and we have a valid legal reason (i.e.,&#160;legal basis) to do
    so under applicable law, like with your consent, to comply with laws, to
    provide you with services to enter into or&#160;fulfill&#160;our contractual
    obligations, to protect your rights, or to&#160;fulfill&#160;our legitimate
    business interests.
  </p>

  <p>If you are located in the EU or UK, this section applies to you.</p>

  <p>
    The General Data Protection Regulation (GDPR) and UK GDPR require us to
    explain the valid legal bases we rely on in order to process your personal
    information. As such, we may rely on the following legal bases to process
    your personal information: Consent.&#160;We may process your information if
    you have given us permission (i.e.,&#160;consent) to use your personal
    information for a specific purpose. You can withdraw your consent at any
    time. Learn more about&#160;withdrawing your consent.
  </p>

  <p>
    Performance of a Contract.&#160;We may process your personal information
    when we believe it is necessary to&#160;fulfill&#160;our contractual
    obligations to you, including providing our Services or at your request
    prior to entering into a contract with you.
  </p>

  <p>
    Legal Obligations.&#160;We may process your information where we believe it
    is necessary for compliance with our legal obligations, such as to cooperate
    with a law enforcement body or regulatory agency, exercise or defend our
    legal rights, or disclose your information as evidence in litigation in
    which we are involved.
  </p>

  <p>
    Vital Interests.&#160;We may process your information where we believe it is
    necessary to protect your vital interests or the vital interests of a third
    party, such as situations involving potential threats to the safety of any
    person.
  </p>

  <p>If you are located in Canada, this section applies to you.</p>

  <p>
    We may process your information if you have given us specific permission
    (i.e.,&#160;express consent) to use your personal information for a specific
    purpose, or in situations where your permission can be inferred
    (i.e.,&#160;implied consent). You can&#160;withdraw your consent&#160;at any
    time.
  </p>

  <p>
    In some exceptional cases, we may be legally permitted under applicable law
    to process your information without your consent, including, for example: If
    collection is clearly in the interests of an individual and consent cannot
    be obtained in a timely way
  </p>

  <p>For investigations and fraud detection and prevention</p>

  <p>For business transactions provided certain conditions are met</p>

  <p>
    If it is contained in a witness statement and the collection is necessary to
    assess, process, or settle an insurance claim
  </p>

  <p>
    For identifying injured, ill, or deceased persons and communicating with
    next of kin
  </p>

  <p>
    If we have reasonable grounds to believe an individual has been, is, or may
    be victim of financial abuse
  </p>

  <p>
    If it is reasonable to expect collection and use with consent would
    compromise the availability or the accuracy of the information and the
    collection is reasonable for purposes related to investigating a breach of
    an agreement or a contravention of the laws of Canada or a province
  </p>

  <p>
    If disclosure is required to comply with a subpoena, warrant, court order,
    or rules of the court relating to the production of records
  </p>

  <p>
    If it was produced by an individual in the course of their employment,
    business, or profession and the collection is consistent with the purposes
    for which the information was produced
  </p>

  <p>
    If the collection is solely for journalistic, artistic, or literary purposes
  </p>

  <p>
    If the information is publicly available and is specified by the regulations
  </p>

  <h2>4. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?</h2>

  <p>
    In Short:&#160;We may share information in specific situations described in
    this section and/or with the following&#160;third parties.
  </p>

  <p>
    We&#160;may need to share your personal information in the following
    situations: Business Transfers.&#160;We may share or transfer your
    information in connection with, or during negotiations of, any merger, sale
    of company assets, financing, or acquisition of all or a portion of our
    business to another company.
  </p>

  <p>
    Other Users.&#160;When you share personal information&#160;(for example, by
    posting comments, contributions, or other content to the Services)&#160;or
    otherwise interact with public areas of the Services, such personal
    information may be viewed by all users and may be publicly made available
    outside the Services in perpetuity.&#160;Similarly, other users will be able
    to view descriptions of your activity, communicate with you within our
    Services, and view your profile.
  </p>

  <h2>5. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?</h2>

  <p>
    In Short:&#160;We may use cookies and other tracking technologies to collect
    and store your information.
  </p>

  <p>
    We may use cookies and similar tracking technologies (like web beacons and
    pixels) to access or store information. Specific information about how we
    use such technologies and how you can refuse certain cookies is set out in
    our Cookie Notice.
  </p>

  <h2>6. HOW LONG DO WE KEEP YOUR INFORMATION?</h2>

  <p>
    In Short:&#160;We keep your information for as long as necessary
    to&#160;fulfill&#160;the purposes outlined in this privacy notice unless
    otherwise required by law.
  </p>

  <p>
    We will only keep your personal information for as long as it is necessary
    for the purposes set out in this privacy notice, unless a longer retention
    period is required or permitted by law (such as tax, accounting, or other
    legal requirements).&#160;No purpose in this notice will require us keeping
    your personal information for longer than&#160;the period of time in which
    users have an account with us.
  </p>

  <p>
    When we have no ongoing legitimate business need to process your personal
    information, we will either delete or&#160;anonymize&#160;such information,
    or, if this is not possible (for example, because your personal information
    has been stored in backup archives), then we will securely store your
    personal information and isolate it from any further processing until
    deletion is possible.
  </p>

  <h2>7. HOW DO WE KEEP YOUR INFORMATION SAFE?</h2>

  <p>
    In Short:&#160;We aim to protect your personal information through a system
    of&#160;organizational&#160;and technical security measures.
  </p>

  <p>
    We have implemented appropriate and reasonable technical
    and&#160;organizational&#160;security measures designed to protect the
    security of any personal information we process. However, despite our
    safeguards and efforts to secure your information, no electronic
    transmission over the Internet or information storage technology can be
    guaranteed to be 100% secure, so we cannot promise or guarantee that
    hackers, cybercriminals, or other&#160;unauthorized&#160;third parties will
    not be able to defeat our security and improperly collect, access, steal, or
    modify your information. Although we will do our best to protect your
    personal information, transmission of personal information to and from our
    Services is at your own risk. You should only access the Services within a
    secure environment.
  </p>

  <h2>8. DO WE COLLECT INFORMATION FROM MINORS?</h2>

  <p>
    In Short:&#160;We do not knowingly collect data from or market
    to&#160;children under 18 years of age.
  </p>

  <p>
    We do not knowingly solicit data from or market to children under 18 years
    of age. By using the Services, you represent that you are at least 18 or
    that you are the parent or guardian of such a minor and consent to such
    minor dependent&rsquo;s use of the Services. If we learn that personal
    information from users less than 18 years of age has been collected, we will
    deactivate the account and take reasonable measures to promptly delete such
    data from our records. If you become aware of any data we may have collected
    from children under age 18, please contact us at&#160;<a
      href="mailto:info@razzle.com"
      >info&#64;razzle.com</a
    >.
  </p>

  <h2>9. WHAT ARE YOUR PRIVACY RIGHTS?</h2>

  <p>
    In Short:&#160;In some regions, such as&#160;the European Economic Area
    (EEA), United Kingdom (UK), and Canada, you have rights that allow you
    greater access to and control over your personal information.&#160;You may
    review, change, or terminate your account at any time.
  </p>

  <p>
    In some regions (like&#160;the EEA, UK, and Canada), you have certain rights
    under applicable data protection laws. These may include the right (i) to
    request access and obtain a copy of your personal information, (ii) to
    request rectification or erasure; (iii) to restrict the processing of your
    personal information; and (iv) if applicable, to data portability. In
    certain circumstances, you may also have the right to object to the
    processing of your personal information. You can make such a request by
    contacting us by using the contact details provided in the
    section&#160;&quot;HOW CAN YOU CONTACT US ABOUT THIS
    NOTICE?&quot;&#160;below.
  </p>

  <p>
    We will consider and act upon any request in accordance with applicable data
    protection laws. &#160; If you are located in the EEA or UK and you believe
    we are unlawfully processing your personal information, you also have the
    right to complain to your&#160;Member State data protection
    authority&#160;or&#160;UK data protection authority.
  </p>

  <p>
    If you are located in Switzerland, you may contact the&#160;Federal Data
    Protection and Information Commissioner.
  </p>

  <p>
    Withdrawing your consent:&#160;If we are relying on your consent to process
    your personal information,&#160;which may be express and/or implied consent
    depending on the applicable law,&#160;you have the right to withdraw your
    consent at any time. You can withdraw your consent at any time by contacting
    us by using the contact details provided in the section&#160;&quot;HOW CAN
    YOU CONTACT US ABOUT THIS NOTICE?&quot;&#160;below&#160;or updating your
    preferences.
  </p>

  <p>
    However, please note that this will not affect the lawfulness of the
    processing before its withdrawal nor,&#160;when applicable law
    allows,&#160;will it affect the processing of your personal information
    conducted in reliance on lawful processing grounds other than consent.
  </p>

  <p>Account Information</p>

  <p>
    If you would at any time like to review or change the information in your
    account or terminate your account, you can: Contact us using the contact
    information provided.
  </p>

  <p>
    Upon your request to terminate your account, we will deactivate or delete
    your account and information from our active databases. However, we may
    retain some information in our files to prevent fraud, troubleshoot
    problems, assist with any investigations, enforce our legal terms and/or
    comply with applicable legal requirements.
  </p>

  <p>
    Cookies and similar technologies:&#160;Most Web browsers are set to accept
    cookies by default. If you prefer, you can usually choose to set your
    browser to remove cookies and to reject cookies. If you choose to remove
    cookies or reject cookies, this could affect certain features or services of
    our Services. You may also&#160;opt out of interest-based advertising by
    advertisers&#160;on our Services.
  </p>

  <p>
    If you have questions or comments about your privacy rights, you may email
    us at&#160;<a href="mailto:info@razzle.com">info&#64;razzle.com</a>.
  </p>

  <h2>10. CONTROLS FOR DO-NOT-TRACK FEATURES</h2>

  <p>
    Most web browsers and some mobile operating systems and mobile applications
    include a Do-Not-Track (&quot;DNT&quot;) feature or setting you can activate
    to signal your privacy preference not to have data about your online
    browsing activities monitored and collected. At this stage no uniform
    technology standard for&#160;recognizing&#160;and implementing DNT signals
    has been&#160;finalized. As such, we do not currently respond to DNT browser
    signals or any other mechanism that automatically communicates your choice
    not to be tracked online. If a standard for online tracking is adopted that
    we must follow in the future, we will inform you about that practice in a
    revised version of this privacy notice.
  </p>

  <h2>11. DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?</h2>

  <p>
    In Short:&#160;Yes, if you are a resident of California, you are granted
    specific rights regarding access to your personal information.
  </p>

  <p>
    California Civil Code Section 1798.83, also known as the&#160;&quot;Shine
    The Light&quot;&#160;law, permits our users who are California residents to
    request and obtain from us, once a year and free of charge, information
    about categories of personal information (if any) we disclosed to third
    parties for direct marketing purposes and the names and addresses of all
    third parties with which we shared personal information in the immediately
    preceding calendar year. If you are a California resident and would like to
    make such a request, please submit your request in writing to us using the
    contact information provided below.
  </p>

  <p>
    If you are under 18 years of age, reside in California, and have a
    registered account with Services, you have the right to request removal of
    unwanted data that you publicly post on the Services. To request removal of
    such data, please contact us using the contact information provided below
    and include the email address associated with your account and a statement
    that you reside in California. We will make sure the data is not publicly
    displayed on the Services, but please be aware that the data may not be
    completely or comprehensively removed from all our systems
    (e.g.,&#160;backups, etc.).
  </p>

  <p>CCPA Privacy Notice</p>

  <p>
    The California Code of Regulations defines
    a&#160;&quot;resident&quot;&#160;as:
  </p>

  <p>
    (1) every individual who is in the State of California for other than a
    temporary or transitory purpose and (2) every individual who is domiciled in
    the State of California who is outside the State of California for a
    temporary or transitory purpose
  </p>

  <p>All other individuals are defined as&#160;&quot;non-residents.&quot;</p>

  <p>
    If this definition of&#160;&quot;resident&quot;&#160;applies to you, we must
    adhere to certain rights and obligations regarding your personal
    information.
  </p>

  <p>How do we use and share your personal information?</p>

  <p>
    More information about our data collection and sharing practices can be
    found in this privacy notice.
  </p>

  <p>
    You may contact us&#160;by email at&#160;<a href="mailto:info@razzle.com"
      >info&#64;razzle.com</a
    >,&#160;or by referring to the contact details at the bottom of this
    document.
  </p>

  <p>
    If you are using an&#160;authorized&#160;agent to exercise your right to opt
    out we may deny a request if the&#160;authorized&#160;agent does not submit
    proof that they have been validly&#160;authorized&#160;to act on your
    behalf.
  </p>

  <p>Will your information be shared with anyone else?</p>

  <p>
    We may disclose your personal information with our service providers
    pursuant to a written contract between us and each service provider. Each
    service provider is a for-profit entity that processes the information on
    our behalf, following the same strict privacy protection obligations
    mandated by the CCPA.
  </p>

  <p>
    We may use your personal information for our own business purposes, such as
    for undertaking internal research for technological development and
    demonstration. This is not considered to be&#160;&quot;selling&quot;&#160;of
    your personal information.
  </p>

  <p>
    NCOM d.o.o.&#160;has not disclosed, sold, or shared any personal information
    to third parties for a business or commercial purpose in the preceding
    twelve (12) months.&#160;NCOM d.o.o.&#160;will not sell or share personal
    information in the future belonging to website visitors, users, and other
    consumers.
  </p>

  <p>Your rights with respect to your personal data</p>

  <p>Right to request deletion of the data &mdash; Request to delete</p>

  <p>
    You can ask for the deletion of your personal information. If you ask us to
    delete your personal information, we will respect your request and delete
    your personal information, subject to certain exceptions provided by law,
    such as (but not limited to) the exercise by another consumer of his or her
    right to free speech, our compliance requirements resulting from a legal
    obligation, or any processing that may be required to protect against
    illegal activities.
  </p>

  <p>Right to be informed &mdash; Request to know</p>

  <p>
    Depending on the circumstances, you have a right to know: whether we collect
    and use your personal information;
  </p>

  <p>the categories of personal information that we collect;</p>

  <p>the purposes for which the collected personal information is used;</p>

  <p>whether we sell or share personal information to third parties;</p>

  <p>
    the categories of personal information that we sold, shared, or disclosed
    for a business purpose;
  </p>

  <p>
    the categories of third parties to whom the personal information was sold,
    shared, or disclosed for a business purpose;
  </p>

  <p>
    the business or commercial purpose for collecting, selling, or sharing
    personal information; and
  </p>

  <p>
    the specific pieces of personal information we collected about you. In
    accordance with applicable law, we are not obligated to provide or delete
    consumer information that is de-identified in response to a consumer request
    or to re-identify individual data to verify a consumer request.
  </p>

  <p>
    Right to Non-Discrimination for the Exercise of a Consumer&rsquo;s Privacy
    Rights
  </p>

  <p>
    We will not discriminate against you if you exercise your privacy rights.
  </p>

  <p>Right to Limit Use and Disclosure of Sensitive Personal Information</p>

  <p>
    If the business collects any of the following: social security information,
    drivers' licenses, state ID cards, passport numbers
  </p>

  <p>account login information</p>

  <p>
    credit card numbers, financial account information, or credentials allowing
    access to such accounts
  </p>

  <p>precise geolocation</p>

  <p>
    racial or ethnic origin, religious or philosophical beliefs, union
    membership
  </p>

  <p>
    the contents of email and text, unless the business is the intended
    recipient of the communication
  </p>

  <p>genetic data, biometric data, and health data</p>

  <p>
    data concerning sexual orientation and sex life you have the right to direct
    that business to limit its use of your sensitive personal information to
    that use which is necessary to perform the Services.
  </p>

  <p>
    Once a business receives your request, they are no longer allowed to use or
    disclose your sensitive personal information for any other purpose unless
    you provide consent for the use or disclosure of sensitive personal
    information for additional purposes.
  </p>

  <p>
    Please note that sensitive personal information that is collected or
    processed without the purpose of inferring characteristics about a consumer
    is not covered by this right, as well as the publicly available information.
  </p>

  <p>
    To exercise your right to limit use and disclosure of sensitive personal
    information, please&#160;email&#160;<a href="mailto:info@razzle.com"
      >info&#64;razzle.com</a
    >&#160;or&#160;submit a&#160;data subject access request.
  </p>

  <p>Verification process</p>

  <p>
    Upon receiving your request, we will need to verify your identity to
    determine you are the same person about whom we have the information in our
    system. These verification efforts require us to ask you to provide
    information so that we can match it with information you have previously
    provided us. For instance, depending on the type of request you submit, we
    may ask you to provide certain information so that we can match the
    information you provide with the information we already have on file, or we
    may contact you through a communication method (e.g.,&#160;phone or email)
    that you have previously provided to us. We may also use other verification
    methods as the circumstances dictate.
  </p>

  <p>
    We will only use personal information provided in your request to verify
    your identity or authority to make the request. To the extent possible, we
    will avoid requesting additional information from you for the purposes of
    verification. However, if we cannot verify your identity from the
    information already maintained by us, we may request that you provide
    additional information for the purposes of verifying your identity and for
    security or fraud-prevention purposes. We will delete such additionally
    provided information as soon as we finish verifying you.
  </p>

  <p>Other privacy rights</p>

  <p>You may object to the processing of your personal information.</p>

  <p>
    You may request correction of your personal data if it is incorrect or no
    longer relevant, or ask to restrict the processing of the information.
  </p>

  <p>
    You can designate an&#160;authorized&#160;agent to make a request under the
    CCPA on your behalf. We may deny a request from
    an&#160;authorized&#160;agent that does not submit proof that they have been
    validly&#160;authorized&#160;to act on your behalf in accordance with the
    CCPA.
  </p>

  <p>
    You may request to opt out from future selling or sharing of your personal
    information to third parties. Upon receiving an opt-out request, we will act
    upon the request as soon as feasibly possible, but no later than fifteen
    (15) days from the date of the request submission. To exercise these rights,
    you can contact us&#160;by email at&#160;<a href="mailto:info@razzle.com"
      >info&#64;razzle.com</a
    >,&#160;or by referring to the contact details at the bottom of this
    document. If you have a complaint about how we handle your data, we would
    like to hear from you.
  </p>

  <h2>12. DO VIRGINIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?</h2>

  <p>
    In Short:&#160;Yes, if you are a resident of Virginia, you may be granted
    specific rights regarding access to and use of your personal information.
  </p>

  <p>Virginia CDPA Privacy Notice</p>

  <p>Under the Virginia Consumer Data Protection Act (CDPA):</p>

  <p>
    &quot;Consumer&quot;&#160;means a natural person who is a resident of the
    Commonwealth acting only in an individual or household context. It does not
    include a natural person acting in a commercial or employment context.
  </p>

  <p>
    &quot;Personal data&quot;&#160;means any information that is linked or
    reasonably linkable to an identified or identifiable natural
    person.&#160;&quot;Personal data&quot;&#160;does not include de-identified
    data or publicly available information.
  </p>

  <p>
    &quot;Sale of personal data&quot;&#160;means the exchange of personal data
    for monetary consideration.
  </p>

  <p>
    If this definition&#160;&quot;consumer&quot;&#160;applies to you, we must
    adhere to certain rights and obligations regarding your personal data.
  </p>

  <p>
    The information we collect, use, and disclose about you will vary depending
    on how you interact with&#160;NCOM d.o.o.&#160;and our Services. To find out
    more, please visit the following links: Personal data we collect
  </p>

  <p>How we use your personal data</p>

  <p>
    When and with whom we share your personal data Your rights with respect to
    your personal data
  </p>

  <p>
    Right to be informed whether or not we are processing your personal data
  </p>

  <p>Right to access your personal data</p>

  <p>Right to correct inaccuracies in your personal data</p>

  <p>Right to request deletion of your personal data</p>

  <p>
    Right to obtain a copy of the personal data you previously shared with us
  </p>

  <p>
    Right to opt out of the processing of your personal data if it is used for
    targeted advertising, the sale of personal data, or profiling in furtherance
    of decisions that produce legal or similarly significant effects
    (&quot;profiling&quot;) NCOM d.o.o.&#160;has not sold any personal data to
    third parties for business or commercial purposes.&#160;NCOM
    d.o.o.&#160;will not sell personal data in the future belonging to website
    visitors, users, and other consumers.
  </p>

  <p>Exercise your rights provided under the Virginia CDPA</p>

  <p>
    More information about our data collection and sharing practices can be
    found in this privacy notice.
  </p>

  <p>
    You may contact us by email at&#160;<a href="mailto:info@razzle.com"
      >info&#64;razzle.com</a
    >,&#160;by submitting a&#160;data subject access request, or by referring to
    the contact details at the bottom of this document.
  </p>

  <p>
    If you are using an&#160;authorized&#160;agent to exercise your rights, we
    may deny a request if the&#160;authorized&#160;agent does not submit proof
    that they have been validly&#160;authorized&#160;to act on your behalf.
  </p>

  <p>Verification process</p>

  <p>
    We may request that you provide additional information reasonably necessary
    to verify you and your consumer's request. If you submit the request through
    an&#160;authorized&#160;agent, we may need to collect additional information
    to verify your identity before processing your request.
  </p>

  <p>
    Upon receiving your request, we will respond without undue delay, but in all
    cases, within forty-five (45) days of receipt. The response period may be
    extended once by forty-five (45) additional days when reasonably necessary.
    We will inform you of any such extension within the initial 45-day response
    period, together with the reason for the extension.
  </p>

  <p>Right to appeal</p>

  <p>
    If we decline to take action regarding your request, we will inform you of
    our decision and reasoning behind it.&#160;If you wish to appeal our
    decision, please email us at&#160;<a href="mailto:info@razzle.com"
      >info&#64;razzle.com</a
    >. Within sixty (60) days of receipt of an appeal, we will inform you in
    writing of any action taken or not taken in response to the appeal,
    including a written explanation of the reasons for the decisions. If your
    appeal if denied, you may contact the&#160;Attorney General to submit a
    complaint.
  </p>

  <h2>13. DO WE MAKE UPDATES TO THIS NOTICE?</h2>

  <p>
    In Short:&#160;Yes, we will update this notice as necessary to stay
    compliant with relevant laws.
  </p>

  <p>
    We may update this privacy notice from time to time. The updated version
    will be indicated by an updated&#160;&quot;Revised&quot;&#160;date and the
    updated version will be effective as soon as it is accessible. If we make
    material changes to this privacy notice, we may notify you either by
    prominently posting a notice of such changes or by directly sending you a
    notification. We encourage you to review this privacy notice frequently to
    be informed of how we are protecting your information.
  </p>

  <h2>14. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</h2>

  <p>
    If you have questions or comments about this notice, you may&#160;email us
    at&#160;<a href="mailto:info@razzle.com">info&#64;razzle.com</a>&#160;or
    contact us by post at:
  </p>

  <p>NCOM d.o.o., Bi&#269;evje 5, 1000 Ljubljana, Slovenia</p>

  <h2>
    15. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?
  </h2>

  <p>
    Based on the applicable laws of your country, you may have the right to
    request access to the personal information we collect from you, change that
    information, or delete it.&#160;To request to review, update, or delete your
    personal information, please&#160;fill out and submit a&#160;data subject
    access request.
  </p>
</div>
